import React, { useState } from "react";
import Gift from "images/gift.png";
import { shopURL } from "utils/constants";
import { sendDataLayerEvent } from "../../helpers/send-event";

const formatDate = (dateStr) => dateStr?.split("-").reverse().join(".");

const Card = ({ content }) => {
  const {
    share_price,
    available_shares,
    syndicate_end_date,
    slug,
    horseState,
    bundleState,
    share_purchase_limit,
    is_racing_club,
    horses,
    buttonText,
    syndicateDateNeverEnds,
    name,
    backpack_id,
  } = content;

  let availableShares = horses ? horses.reduce((minShares, horse) => horse.available_shares < minShares ? horse.available_shares : minShares, horses[0].available_shares) : available_shares;
  let sharePrice = horses ? horses.reduce((total, horse) => total + horse.price, 0) : share_price;
  let syndicateEndDate = horses ? horses.reduce((earliest, horse) => {
    let horseDate = new Date(horse.syndicate_end_date);
    return horseDate < earliest ? horseDate : earliest;
  }, new Date(horses[0].syndicate_end_date)).toISOString().split('T')[0] : syndicate_end_date;

  let state = horses ? bundleState : horseState;

  const hideInfo = state === "comming soon" || state === "syndicated";

  const [open, setOpen] = useState(true);
  const [sharesToBuy, setSharesToBuy] = useState(1);

  const formatePrice = (num) => {
    return num.toFixed(2).replace(/\.00$/, "");
  };

  const openTab = (url) => {
    window.open(url, "_blank");
  };

  const ctaButtonText = () => {
    if (buttonText) return buttonText;
    return is_racing_club ? 'Buy Membership' : horses ? 'Buy Bundle' : 'Buy Shares';
  }

  return (
    <div className="relative">
      <div className="hidden sm:block relative" onClick={() => setOpen(!open)}>
        <div className="w-28 h-1.5 bg-gray-400 mx-auto rounded-xl" />
        <h2 className="paragraph text-gray-900 mt-2.5 text-center">
          Become an Owner
        </h2>
        <button
          className={`text-xs font-sans font-semibold underline text-gray-900 absolute top-0 right-0 ${
            open ? "block" : "hidden"
          }`}
          onClick={() => setOpen(false)}
        >
          Close
        </button>
      </div>
      <div className={`${open ? "sm:block" : "sm:hidden"}`}>
        <h3 className="header !font-sans !text-yellow-400 text-center mt-4 !font-extrabold overflow-hidden">
          {state === "comming soon" && "COMING SOON"}
          {state === "syndicated" && "SOLD OUT"}
          {!hideInfo && `£${formatePrice(sharePrice * sharesToBuy)}`}
          {is_racing_club && <span className="text-xs mx-2">per month</span>}
        </h3>
        <div className="flex justify-center gap-8 my-4">
          {
            syndicateEndDate &&
            <div className="text-center">
              <h3 className="font-sans text-xs text-yellow-500">
                Syndicate term ends
              </h3>
              <h4 className="font-sans font-bold text-sm text-gray-800 mt-1">
                {(is_racing_club || syndicateDateNeverEnds) ? 'Never' : formatDate(syndicateEndDate)}
              </h4>
          </div>
          }
          {!hideInfo && (
            <div className="text-center">
              <h3 className="font-sans text-xs text-yellow-500">{is_racing_club ? 'No.places' : horses ? 'No.bundles' : 'No.shares'}</h3>
              <h4 className="font-sans font-bold text-sm text-gray-800 mt-1">
                {availableShares < 100000 ? (
                  availableShares
                ) : (
                  <span className="text-2xl font-extrabold leading-none">
                    &#8734;
                  </span>
                )}
              </h4>
            </div>
          )}
        </div>
        {hideInfo ? (
          <a className="btn btn-primary w-full my-4" href="#waiting_list">
            {
              buttonText || 
              (
                (state === "syndicated" || state === "comming soon")
                ? "Join waiting list"
                : horses ? "Reserve a bundle" : "Reserve a share"
              )
            }
          </a>
        ) : (
          <>
            <div className="flex my-4 gap-2">
              <input
                onChange={({ target: { value } }) => {
                  const modified_value =
                    value > share_purchase_limit ? share_purchase_limit : value;
                  setSharesToBuy(modified_value);
                }}
                className="border-solid border border-gray-400 rounded-md p-4 font-sans font-bold text-sm text-gray-800 outline-none w-1/2"
                value={sharesToBuy}
                min={1}
                type="number"
              />
              <button
                className="btn btn-primary w-1/2"
                onClick={async () => {
                  sendDataLayerEvent("add_to_cart", {
                      value: sharePrice * +sharesToBuy,
                      items: [{
                          item_id: backpack_id,
                          item_name: name,
                          item_category: 'horse',
                          price: sharePrice,
                          quantity: +sharesToBuy
                      }]
                  });
                  openTab(is_racing_club 
                    ? `${shopURL}/subscription/${slug}` 
                    : horses 
                      ? `${shopURL}/bundle/${slug}?number_of_shares=${sharesToBuy}` 
                      : `${shopURL}/${slug}?number_of_shares=${sharesToBuy}`);
                }}
              >
                {ctaButtonText()}
              </button>
            </div>
            {
              slug !== 'cropredy-law-racing-club' && 
              <button
                className="btn btn-white w-full !bg-[#EFF4F2]"
                onClick={() =>
                  openTab(
                    horses ? 
                    `${shopURL}/bundle/${slug}?number_of_shares=${sharesToBuy}&gift=true`
                    :
                    `${shopURL}/${slug}?number_of_shares=${sharesToBuy}&gift=true`
                  )
                }
              >
                Send as a gift{" "}
                <img src={Gift} alt="gift logo" className="w-6 h-6" />
              </button>
            }
          </>
        )}
      </div>
    </div>
  );
};

export default Card;
